/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Refundtype2Inputs */

const id_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Pengembalian Dana`)
};

const ms_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Bayaran Balik`)
};

const da_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunderingstype`)
};

const de_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückerstattungstyp`)
};

const en_us2_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund Type`)
};

const es_es2_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de reembolso`)
};

const es_mx2_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de reembolso`)
};

const fil_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri ng Refund`)
};

const fr_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de remboursement`)
};

const it_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di rimborso`)
};

const hu_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visszatérítés típusa`)
};

const nl_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terugbetalingstype`)
};

const no_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunderings type`)
};

const pl_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ zwrotu`)
};

const pt_br2_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de reembolso`)
};

const pt_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de reembolso`)
};

const ro_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip rambursare`)
};

const fi_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyvitystyyppi`)
};

const sv_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Återbetalningstyp`)
};

const vi_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại hoàn tiền`)
};

const tr_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İade Türü`)
};

const cs_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ vrácení`)
};

const bg_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип връщане`)
};

const ru_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип возврата`)
};

const uk_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип повернення`)
};

const ar_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الاسترداد`)
};

const hi_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिफ़ंड प्रकार`)
};

const th_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภทการคืนเงิน`)
};

const ja_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返金タイプ`)
};

const zh_cn2_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退款类型`)
};

const zh_hant1_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`退款類型`)
};

const ko_offerdetail_table_refundtype2 = /** @type {(inputs: Offerdetail_Table_Refundtype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`환불 유형`)
};

/**
* | output |
* | --- |
* | "Refund Type" |
*
* @param {Offerdetail_Table_Refundtype2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_refundtype2 = /** @type {((inputs?: Offerdetail_Table_Refundtype2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Refundtype2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_refundtype2(inputs)
	if (locale === "ms") return ms_offerdetail_table_refundtype2(inputs)
	if (locale === "da") return da_offerdetail_table_refundtype2(inputs)
	if (locale === "de") return de_offerdetail_table_refundtype2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_refundtype2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_refundtype2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_refundtype2(inputs)
	if (locale === "fil") return fil_offerdetail_table_refundtype2(inputs)
	if (locale === "fr") return fr_offerdetail_table_refundtype2(inputs)
	if (locale === "it") return it_offerdetail_table_refundtype2(inputs)
	if (locale === "hu") return hu_offerdetail_table_refundtype2(inputs)
	if (locale === "nl") return nl_offerdetail_table_refundtype2(inputs)
	if (locale === "no") return no_offerdetail_table_refundtype2(inputs)
	if (locale === "pl") return pl_offerdetail_table_refundtype2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_refundtype2(inputs)
	if (locale === "pt") return pt_offerdetail_table_refundtype2(inputs)
	if (locale === "ro") return ro_offerdetail_table_refundtype2(inputs)
	if (locale === "fi") return fi_offerdetail_table_refundtype2(inputs)
	if (locale === "sv") return sv_offerdetail_table_refundtype2(inputs)
	if (locale === "vi") return vi_offerdetail_table_refundtype2(inputs)
	if (locale === "tr") return tr_offerdetail_table_refundtype2(inputs)
	if (locale === "cs") return cs_offerdetail_table_refundtype2(inputs)
	if (locale === "bg") return bg_offerdetail_table_refundtype2(inputs)
	if (locale === "ru") return ru_offerdetail_table_refundtype2(inputs)
	if (locale === "uk") return uk_offerdetail_table_refundtype2(inputs)
	if (locale === "ar") return ar_offerdetail_table_refundtype2(inputs)
	if (locale === "hi") return hi_offerdetail_table_refundtype2(inputs)
	if (locale === "th") return th_offerdetail_table_refundtype2(inputs)
	if (locale === "ja") return ja_offerdetail_table_refundtype2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_refundtype2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_refundtype2(inputs)
	return ko_offerdetail_table_refundtype2(inputs)
});
export { offerdetail_table_refundtype2 as "offerDetail.table.refundType" }